// @flow strict

import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { Grid } from '@material-ui/core';

import { AuthorPreview } from '~components/author/author-preview';
import { useLanguageContext } from '~contexts/language-context';
import { createLinkPath } from '~utils/helpers/create-link-path';

import * as styles from './about-us.module.less';

/**
 * About us component.
 * Displays preview of 3 authors and a link to
 * all authors page.
 *
 * @returns {Node}
 */
export const AboutUs = () => {
  const { language, loc } = useLanguageContext();

  const data = useStaticQuery(graphql`
    query {
      allAuthorJson {
        nodes {
          ...Author
        }
      }
      allMarkdownRemark {
        group(field: frontmatter___author) {
          totalCount
          fieldValue
        }
        totalCount
      }
    }
  `);

  // get graphql result
  const [firstAuthor, secondAuthor, thirdAuthor] = data.allMarkdownRemark.group
    .sort((a, b) => b.totalCount - a.totalCount)
    .slice(0, 3)
    .map((entry) => {
      return data.allAuthorJson.nodes.find(
        (author) => author.name === entry.fieldValue,
      );
    });

  return (
    <section className={styles.aboutUs}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={8}>
          <div className={styles.banner}>
            <p className={styles.teaser}>{loc('_about_us_teaser')}</p>
            <h3 className={styles.headline}>{loc('_about_us_headline')}</h3>
            <p className={styles.text}>{loc('_about_us_text')}</p>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <AuthorPreview
            author={firstAuthor}
            className={styles.authorPreview}
          />
          <AuthorPreview
            author={secondAuthor}
            className={styles.authorPreview}
          />
          <AuthorPreview
            author={thirdAuthor}
            className={styles.authorPreview}
          />
          <Link
            to={createLinkPath({ path: '/blog/authors', language })}
            className={styles.seeAll}
          >
            {loc('_about_us_see_all')}
          </Link>
        </Grid>
      </Grid>
    </section>
  );
};
